"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pointsPerTier = exports.LoyaltyVector = void 0;
var LoyaltyVector;
(function (LoyaltyVector) {
    LoyaltyVector["Static"] = "static";
    LoyaltyVector["Increasing"] = "increasing";
    LoyaltyVector["Decreasing"] = "decreasing";
})(LoyaltyVector || (exports.LoyaltyVector = LoyaltyVector = {}));
exports.pointsPerTier = {
    bronze: 4,
    silver: 8,
    gold: 12,
    platinum: 16,
};
